export enum ScenarioSubTab {
  SETUP = 'setup',
  RESULTS = 'results',
  APPLIED = 'applied',
}
